import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v1/bank-account/change-request';
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  /** @param {import('./typedefs').RequestPayload} payload */
  return async (payload) => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.post(url, payload);

      return res.data;
    } catch (err) {
      const resp = err?.response?.data;
      errorLogger('ERROR_API', resp?.err_message || err.message);
      throw resp;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
